import { Component , OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpUtils } from 'common';

@Component({
    selector: 'disaster-recovery-embed',
    template: require('./disaster-recovery-embed.html'),
    styles: [require('./disaster-recovery-embed.scss')]
})

export default class DisasterRecoveryEmbed implements OnInit {

    public iframeUrl;
    constructor( private sanitizer: DomSanitizer) {
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${HttpUtils.getUiMountPoint()}/dr-ui/index.html`);
     }

    public ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/disaster-recovery/disaster-recovery-embed.ts